module.exports = __webpack_public_path__ + "static/media/icon-snowflake.42993d22.svg";